import * as PerformanceReportActions from '../actions/performance-report.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  isLoading: false,
  loadingById: {},
  pathSuccess: null,
};

export default function performanceReport(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case PerformanceReportActions.LOAD:
    case PerformanceReportActions.LOAD_ONE:
      // case RequirementsActions.LOAD_CONTRACT:
      // case AlarmVelActions.CREATE:
      return {
        ...state,
        isLoading: true,
      };

    case PerformanceReportActions.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        // entities: action.data.reduce((acc, item) => {
        //   acc[item.tmp_device2] = item;
        //   return acc;
        // }, {}),
        entities: action.data,

        // ids: action.data.map((x) => x.tmp_device2),
        // pathSuccess: null,
      };
    case PerformanceReportActions.LOAD_SUCCESS_ONE:
      return {
        ...state,
        isLoading: false,
        entities: action.data /* .reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.id), */,
        pathSuccess: null,
      };

    case PerformanceReportActions.VOID:
      return {
        ...state,
        isLoading: false,
        entities: {},
        ids: [],
        group: {},
      };
    default:
      return state;
  }
}

export const getEntities = (state) => state.performanceReport.entities;
export const getData = (state) => state.performanceReport.ids.map((id) => state.performanceReport.entities[id]);
export const getDataById = (state, id) => state.performanceReport.entities[id];
export const getIsLoading = (state) => state.performanceReport.isLoading;
// aths
export const getPath = (state) => state.performanceReport.pathSuccess;
